import clsx from "clsx";
import RefreshIcon from "ui/common/icons/RefreshIcon";
import { RefreshIconButtonRoot } from "./RefreshIconButton.styles";
import { useEffect, useState } from "react";
import { RefreshIconButtonProps } from "./RefreshIconButton.types";

export const REFRESH_ICON_ANIMATION_DURATION = 1125;

function RefreshIconButton({ className, onRefresh, refreshing, ...rest }: RefreshIconButtonProps) {
    const [rotating, setRotating] = useState(refreshing);
    // skipcq: JS-0045
    useEffect(() => {
        if (refreshing) {
            setRotating(true);
        } else {
            const timeout = setTimeout(() => {
                setRotating(false);
            }, REFRESH_ICON_ANIMATION_DURATION);
            return () => clearTimeout(timeout);
        }
    }, [refreshing]);

    return (
        <RefreshIconButtonRoot
            className={clsx("refresh-icon-button", className)}
            onClick={onRefresh}
            disabled={rotating}
            refreshing={rotating}
            {...rest}
        >
            <RefreshIcon />
        </RefreshIconButtonRoot>
    );
}

export default RefreshIconButton;
